import React from "react";

export default function EvidenceDownloader({ logs, filename = "mvelio-audit-trail" }) {
  const downloadCSV = () => {
    if (!logs || logs.length === 0) return;

    // 1. Define standard, spreadsheet-compatible CSV Headers
    const headers = ["Timestamp (UTC)", "Scraper Identity", "Classification Type", "Detection Reason", "Page URL Target"];

    // 2. Safely map and sanitize rows (encapsulating strings in double-quotes to handle commas)
    const csvRows = [
      headers.join(","), // Append header row
      ...logs.map((log) => {
        // Safe Date formatting
        const timestamp = log.timestamp instanceof Date 
          ? log.timestamp.toISOString() 
          : new Date(log.timestamp).toISOString();

        return [
          `"${timestamp}"`,
          `"${(log.botName || "").replace(/"/g, '""')}"`, // Escape inner double-quotes
          `"${(log.botType || "").replace(/"/g, '""')}"`,
          `"${(log.botReason || "").replace(/"/g, '""')}"`,
          `"${(log.pageUrl || "").replace(/"/g, '""')}"`
        ].join(",");
      })
    ];

    // 3. Create a UTF-8 CSV Blob and trigger a secure, browser-native download
    const blob = new Blob([csvRows.join("\n")], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    
    link.setAttribute("href", url);
    link.setAttribute("download", `${filename}-${Date.now()}.csv`);
    link.style.visibility = "hidden";
    
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url); // Clean up memory allocation
  };

  return (
    <button
      onClick={downloadCSV}
      disabled={!logs || logs.length === 0}
      className="evidence-download-btn"
      style={{
        padding: "10px 18px",
        backgroundColor: !logs || logs.length === 0 ? "#1e293b" : "#10b981",
        color: !logs || logs.length === 0 ? "#64748b" : "#fff",
        border: "none",
        borderRadius: "6px",
        fontWeight: "bold",
        cursor: !logs || logs.length === 0 ? "not-allowed" : "pointer",
        display: "inline-flex",
        alignItems: "center",
        gap: "8px",
        fontSize: "14px",
        transition: "background-color 0.2s"
      }}
    >
      📥 Download Audit Evidence (.CSV)
    </button>
  );
}
